var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinevector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 2,
    viewBox: "0 0 55 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 1H0",
    stroke: "url(#linevector_svg__paint0_linear_3575_5950)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linevector_svg__paint0_linear_3575_5950",
    x1: 55,
    y1: 1.5,
    x2: 0,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41216B",
    stopOpacity: 0
  })))));
}
export default SvgLinevector;